import './modal.css'

const Modal = ({isOpen, toggle, item}) => {
    return (
        <div>
            {
                isOpen &&
                <div className={'modal_father'}>
                    <div className="menu_modal">
                        <div className="modal_left_side">
                            <img src={item.img} alt="img"/>
                        </div>
                        <div className="modal_right_side">
                            <div className="modal_right_side_title">{item.name}</div>
                            <div className="modal_right_side_desc">{item.desc}</div>
                            <div className="modal_right_side_price">{item.price}</div>
                        </div>
                        <button className="close_button" onClick={toggle}>X</button>
                    </div>
                </div>
            }
        </div>
    )
}

export default Modal
